import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  createDealerScheme,
  deleteDealerScheme,
  getDealerSchemeById,
  getDealerSchemeList,
  updateDealerScheme,
} from '../../services/DealerSchemeService'

interface GetDealerSchemeListParams {
  pageNumber: number
  pageSize: number
  filterkey: any
}

interface DealerSchemeState {
  DealerSchemeList: any
  dealerScheme: any
}

const initialState: DealerSchemeState = {
  DealerSchemeList: null,
  dealerScheme: null,
}

// Fetch Dealer Scheme list
export const getDealerSchemeListApi = createAsyncThunk(
  'dealerScheme/getDealerSchemeList',
  async ({pageNumber, pageSize, filterkey}: GetDealerSchemeListParams, {rejectWithValue}) => {
    try {
      const result = await getDealerSchemeList(pageNumber, pageSize, filterkey)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Fetch Dealer Scheme by ID
export const getDealerSchemeByIdApi = createAsyncThunk(
  'dealerScheme/getDealerSchemeById',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await getDealerSchemeById(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Create a new Dealer Scheme
export const createDealerSchemeApi = createAsyncThunk(
  'dealerScheme/createDealerScheme',
  async (payload: any, {rejectWithValue}) => {
    try {
      const result = await createDealerScheme(payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Update Dealer Scheme
export const updateDealerSchemeApi = createAsyncThunk(
  'dealerScheme/updateDealerScheme',
  async ({id, payload}: {id: any; payload: any}, {rejectWithValue}) => {
    try {
      const result = await updateDealerScheme(id, payload)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

// Delete Dealer Scheme
export const deleteDealerSchemeApi = createAsyncThunk(
  'dealerScheme/deleteDealerScheme',
  async (id: any, {rejectWithValue}) => {
    try {
      const result = await deleteDealerScheme(id)
      return result.data
    } catch (error) {
      return rejectWithValue({error})
    }
  }
)

const DealerSchemeSlice = createSlice({
  name: 'dealerScheme',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getDealerSchemeListApi.fulfilled, (state, action) => {
        state.DealerSchemeList = action.payload
      })
      .addCase(getDealerSchemeByIdApi.fulfilled, (state, action) => {
        state.dealerScheme = action.payload
      })
      .addCase(createDealerSchemeApi.fulfilled, (state, action) => {
        state.dealerScheme = action.payload
      })
      .addCase(updateDealerSchemeApi.fulfilled, (state, action) => {
        state.dealerScheme = action.payload
      })
      .addCase(deleteDealerSchemeApi.fulfilled, (state, action) => {
        state.dealerScheme = null
      })
  },
})

export default DealerSchemeSlice

